import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export const MoveIcon = ({ size = 17, color = Color.Black, opacity = 1, className }: IconProps) => (
  <svg
    width={size}
    height={(size * 16) / 17}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    opacity={opacity}
    className={className}>
    <path
      d="M3.90004 14.4167C3.46671 14.4167 3.09726 14.2639 2.79171 13.9583C2.48615 13.6528 2.33337 13.2833 2.33337 12.85V3.15C2.33337 2.71667 2.48615 2.34444 2.79171 2.03333C3.09726 1.72222 3.46671 1.56667 3.90004 1.56667H8.40004V3.15H3.90004V12.85H13.6V8.35H15.1834V12.85C15.1834 13.2833 15.0278 13.6528 14.7167 13.9583C14.4056 14.2639 14.0334 14.4167 13.6 14.4167H3.90004ZM7.50004 10.35L6.41671 9.25L12.5167 3.15H9.40004V1.56667H15.1834V7.35H13.6V4.25L7.50004 10.35Z"
      fill={color}
    />
  </svg>
);
